import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class ScrollService {
    private scrollPosition: string = "";

    constructor() { }

    getScrollPosition(): string {
        return this.scrollPosition;
    }

    setScrollPosition(position: string): void {
        this.scrollPosition = position;
    }
}